export var E_USERS_ACTION_TYPES;
(function (E_USERS_ACTION_TYPES) {
    E_USERS_ACTION_TYPES["FETCH_USERS_REQUESTED"] = "FETCH_USERS_REQUESTED";
    E_USERS_ACTION_TYPES["FETCH_USERS_SUCCEEDED"] = "FETCH_USERS_SUCCEEDED";
    E_USERS_ACTION_TYPES["UPDATE_USERS_COLLECTION_LOADING"] = "UPDATE_USERS_COLLECTION_LOADING";
    E_USERS_ACTION_TYPES["SAVE_USERS_ALL_COLUMNS"] = "SAVE_USERS_ALL_COLUMNS";
    E_USERS_ACTION_TYPES["UPDATE_USERS_COLUMN"] = "UPDATE_USERS_COLUMN";
    E_USERS_ACTION_TYPES["UPDATE_USERS_FILTERS_REQUESTED"] = "UPDATE_USERS_FILTERS_REQUESTED";
    E_USERS_ACTION_TYPES["UPDATE_USERS_FILTERS_SUCCEEDED"] = "UPDATE_USERS_FILTERS_SUCCEEDED";
    E_USERS_ACTION_TYPES["EXPORT_USERS_IN_CSV_REQUESTED"] = "EXPORT_USERS_IN_CSV_REQUESTED";
    E_USERS_ACTION_TYPES["IMPORT_USERS_IN_CSV_REQUESTED"] = "IMPORT_USERS_IN_CSV_REQUESTED";
    E_USERS_ACTION_TYPES["IMPORT_USERS_IN_CSV_SUCCEEDED"] = "IMPORT_USERS_IN_CSV_SUCCEEDED";
    E_USERS_ACTION_TYPES["UPDATE_USERS_IMPORT_LOADING"] = "UPDATE_USERS_IMPORT_LOADING";
    E_USERS_ACTION_TYPES["CLEAR_USERS_IMPORT"] = "CLEAR_USERS_IMPORT";
    E_USERS_ACTION_TYPES["FETCH_CURRENT_USER_DETAILS_REQUESTED"] = "FETCH_CURRENT_USER_DETAILS_REQUESTED";
    E_USERS_ACTION_TYPES["FETCH_CURRENT_USER_DETAILS_SUCCEEDED"] = "FETCH_CURRENT_USER_DETAILS_SUCCEEDED";
    E_USERS_ACTION_TYPES["CLEAR_CURRENT_USER"] = "CLEAR_CURRENT_USER";
    E_USERS_ACTION_TYPES["UPDATE_USER_REQUESTED"] = "UPDATE_USER_REQUESTED";
    E_USERS_ACTION_TYPES["DELETE_USER_REQUESTED"] = "DELETE_USER_REQUESTED";
})(E_USERS_ACTION_TYPES || (E_USERS_ACTION_TYPES = {}));
